import React, { Fragment, useState, useEffect } from "react";
import { Button, Result, Spin, Radio, Modal, Form, Select } from "antd";
import { useHistory } from "react-router-dom";
import {
  TitleHeader,
  UserCard,
  ButtonDownload,
  CredencialButton
} from "../../../components/commons";
import { updateUnsafe, getByDNI } from "../../../api/participante";
import { previewFile } from "../../../api/sistema";
import {
  shortName,
  estadoParticipante,
  openNotificationWithIcon,
  viewFileByUrl
} from "../../../utils/functions";
import { useAuth } from "../../../utils/useAuth";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  ReloadOutlined
} from "@ant-design/icons";

import ActualizarDatos from "./ActualizarDatos";
import FOTO_DEFAULT from "../../../assets/user_icon.png";
import IMAGE_DNI from "../../../assets/dni.jpg";
// import IMAGE_VACUNACION from "../../assets/vacunacion.png";
import IMAGE_FICHA_MATRICULA from "../../../assets/ficha-matricula.png";
import IMAGE_FOTO_DEL_ROSTRO from "../../../assets/foto-rostro.png";
import IMAGE_DECLARACION_JURADA from "../../../assets/declaracion-jurada.png";
import IMAGE_CURRICULUM_VITAE from "../../../assets/cv.png";
import Adjuntado from "./Adjuntado";
import UploadDeleteDocument from "./UploadDeleteDocument";
import * as SHARED from "../../../utils/shared";

const { confirm } = Modal;
const { Option } = Select;

function Revision(props) {
  const [isDatosAccesoVisible, setIsDatosAccesoVisible] = useState(false);
  const nrodocumento = props.match.params.nrodocumento;

  const history = useHistory();
  const { isAdmin } = useAuth();
  const [data, setData] = useState({
    apellido: "",
    email: "",
    idcondicioncontrato: null,
    idespecialidad: null,
    idasignatura: null,
    idestado: null,
    idfacultad: null,
    idoficina: null,
    idcarrera: null,
    idtipoparticipacion: null,
    idtipoparticipante: null,
    isCurriculumOk: null,
    idgradoacademico: null,
    isDeclaracionJuradaOk: null,
    isDocumentoOk: null,
    isFotoOk: null,
    isUploadedCredencial: null,
    nombre: "",
    password: "",
    nrocelular: "",
    correlativo: "",
    nrodocumento: "",
    numberConstancyDownloads: 0,
    participafecha1: null,
    participafecha2: null,
    urlCurriculum: "",
    urlDeclaracionJurada: "",
    urlDocumento: "",
    urlFoto: "",
    _id: ""
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [reload, setReload] = useState(false);

  const fetchParticipante = async () => {
    try {
      setIsLoading(true);
      const res = await getByDNI(nrodocumento);
      setData(res.payload);
    } catch (error) {
      setError(error);
      setIsError(true);
      setData({});
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchParticipante();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  const toggleVisibleDatos = () => {
    setIsDatosAccesoVisible(!isDatosAccesoVisible);
  };

  const showChangeStateConfirm = (newState) => {
    confirm({
      title: (
        <p>
          ¿Estás seguro que deseas cambiar el estado a
          <b className="text-blue-600"> {estadoParticipante(newState)}?</b>
        </p>
      ),
      icon: <ExclamationCircleOutlined />,
      async onOk() {
        try {
          const res = await updateUnsafe({ idestado: newState }, data._id);
          openNotificationWithIcon("success", res.message);
          window.location.reload();
        } catch (err) {
          openNotificationWithIcon("error", err.message);
        }
      },
      onCancel() {
        return null;
      }
    });
  };

  const changeAttachedState = async (urlOkName, newState) => {
    try {
      const res = await updateUnsafe({ [urlOkName]: newState }, data._id);
      openNotificationWithIcon("success", res.message);
    } catch (err) {
      openNotificationWithIcon("error", err.message);
    }
  };

  const buttonsDisabled =
    data.idestado === SHARED.ID_ESTADO_VALIDADO || data.idestado === SHARED.ID_ESTADO_SORTEADO;

  const getParticipantType = (idtipoparticipante) => {
    if (idtipoparticipante === SHARED.ID_ESTUDIANTE) {
      return "ESTUDIANTE";
    }

    if (idtipoparticipante === SHARED.ID_DOCENTE) {
      return "DOCENTE";
    }

    if (idtipoparticipante === SHARED.ID_ADMINISTRATIVO) {
      return "ADMINISTRATIVO";
    }
  };

  const getModalidad = (idtipoparticipacion) => {
    if (idtipoparticipacion === SHARED.ID_SUPERVISION) {
      return "SUPERVISIÓN";
    }

    if (idtipoparticipacion === SHARED.ID_INTERNAMIENTO) {
      return "INTERNAMIENTO";
    }
  };

  const handleFuncionesExtra = async (values = {}) => {
    console.log(values);

    const isConfirm = window.confirm(
      "¿Estás seguro de cambiar el tipo de participante o modalidad?"
    );

    if (isConfirm) {
      const registerId = data._id;
      try {
        const res = await updateUnsafe(values, registerId);
        if (res.success) openNotificationWithIcon("success", res.message);
        window.location.reload();
        return;
      } catch (err) {
        openNotificationWithIcon("error", err.message);
      }
    }
  };

  // const viewFileByUrl = (type, nombreArchivo) =>
  //   `${BASE_PATH}/${API_VERSION}/sistema/view?type=${type}&file=${nombreArchivo}&token=${ACCESS_TOKEN}`;

  return (
    <Fragment>
      <TitleHeader
        title={
          <h3>
            REVISIÓN DE DOCUMENTOS &nbsp;
            <span className="text-base font-bold text-blue-500 uppercase">
              {getParticipantType(data.idtipoparticipante)}
            </span>
            {" | "}
            <span className="text-base font-bold text-blue-500 uppercase">
              {getModalidad(data.idtipoparticipacion)}
            </span>
            <span>
              &nbsp;
              <Button icon={<ReloadOutlined />} onClick={() => setReload(!reload)}></Button>
            </span>
          </h3>
        }
        extra={<h3 className="text-md font-bold mt-2 mr-6">{SHARED.PROCESO}</h3>}
        onBack={() => history.goBack()}
      />

      <div className="lg:flex w-full">
        {/* ---------- CARD PROFILE ---------- */}
        <div className="w-full mb-8 md:w-1/2 md:mx-auto lg:w-1/6 text-center">
          <UserCard
            image={
              data.urlFoto
                ? viewFileByUrl("foto_rostro", data.nrodocumento + "-FOT.jpg")
                : FOTO_DEFAULT
            }
            title={shortName(data.nombre, data.apellido)}
            subTitle={data.nrodocumento}
            state={data.idestado}
          />

          <div className="my-3 w-full">
            {data.idestado === SHARED.ID_ESTADO_SORTEADO && (
              <div className="flex flex-col justify-center mt-4">
                <CredencialButton user={data} />
              </div>
            )}
            {/* <Upload
              {...uploadProps({
                name: "attached",
                action: "/sistema/upload-files",
                data: { type: "credencial_participante", nrodocumento: data.nrodocumento },
                makeReload: () => setReload(!reload)
              })}
              accept=".pdf"
              maxCount={1}
              className="subir-credencial"
            >
              <Button className="w-full" block icon={<UploadOutlined />}>
                Subir credencial
              </Button>
            </Upload> */}
          </div>

          {data.urlCredencial && (
            <div>
              <ButtonDownload
                className="w-full mb-3"
                type="default"
                icon={<DownloadOutlined />}
                buttonTitle="Descargar credencial"
                fileName={`${data.nrodocumento}-CREDENCIAL.pdf`}
                onDownload={() =>
                  previewFile("credencial_participante", `${data.nrodocumento}-CREDENCIAL.pdf`)
                }
              />
            </div>
          )}

          {isAdmin && (
            <div>
              <hr className="mt-4" />
              <h2 className="text-md font-bold mb-4 mt-2 text-blue-500">FUNCIONES EXTRA</h2>

              <Form layout="vertical" onFinish={handleFuncionesExtra}>
                <Form.Item
                  label="Participante"
                  name="idtipoparticipante"
                  initialValue={data.idtipoparticipante}
                >
                  <Select>
                    <Option value={SHARED.ID_ESTUDIANTE}>Estudiante</Option>
                    <Option value={SHARED.ID_DOCENTE}>Docente</Option>
                    <Option value={SHARED.ID_ADMINISTRATIVO}>Administrativo</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Modalidad"
                  name="idtipoparticipacion"
                  initialValue={data.idtipoparticipacion}
                >
                  <Select>
                    <Option value={SHARED.ID_SUPERVISION}>Supervisión</Option>
                    <Option value={SHARED.ID_INTERNAMIENTO}>Internamiento</Option>
                  </Select>
                </Form.Item>

                <Form.Item>
                  <Button type="primary" block htmlType="submit">
                    Guardar cambios
                  </Button>
                </Form.Item>
              </Form>

              {/* --------- Botones de subida de archivos --- */}

              <UploadDeleteDocument
                title="Nro. de documento"
                type="documento_identidad"
                recordId={data._id}
                nrodocumento={data.nrodocumento}
                urlName="urlDocumento"
                existUrl={!!data.urlDocumento}
              />

              <UploadDeleteDocument
                title="Declaración Jurada"
                type="declaracion_jurada"
                recordId={data._id}
                nrodocumento={data.nrodocumento}
                urlName="urlDeclaracionJurada"
                existUrl={!!data.urlDeclaracionJurada}
              />

              <UploadDeleteDocument
                title="Foto del rostro"
                type="foto_rostro"
                recordId={data._id}
                nrodocumento={data.nrodocumento}
                urlName="urlFoto"
                existUrl={!!data.urlFoto}
                accept=".jpg"
              />

              <UploadDeleteDocument
                title="Curriculum vitae"
                type="carne_vacunacion"
                recordId={data._id}
                nrodocumento={data.nrodocumento}
                urlName="urlCurriculum"
                existUrl={!!data.urlCurriculum}
              />
            </div>
          )}
        </div>

        {/* ---------- DATOS GENERALES ---------- */}

        <div className="w-full mb-8 lg:w-3/6 lg:px-10">
          <h2 className="text-md font-bold mb-4 ">DATOS DEL PARTICIPANTE</h2>
          <ActualizarDatos participante={data} buttonsDisabled={buttonsDisabled} />
        </div>

        {/* ---------- ARCHIVOS ADJUNTADO ---------- */}

        <div className="w-full lg:w-2/6">
          <h2 className="text-md font-bold mb-4 text-blue-500">ARCHIVOS ADJUNTADOS</h2>

          <div className="mb-8">
            {data.idtipoparticipante === SHARED.ID_ESTUDIANTE && (
              <Adjuntado
                miniatura={data.urlDocumento && IMAGE_FICHA_MATRICULA}
                title="FICHA DE MATRÍCULA"
                type="documento_identidad"
                downloadFileName={`${data.nrodocumento}-DOC.pdf`}
                onDownload={() =>
                  previewFile("documento_identidad", `${data.nrodocumento}-DOC.pdf`)
                }
                url={data.urlDocumento}
                isUrlOk={data.isDocumentoOk}
                urlOkName="isDocumentoOk"
                changeAttachedState={changeAttachedState}
              />
            )}
            {(data.idtipoparticipante === SHARED.ID_ADMINISTRATIVO ||
              data.idtipoparticipante === SHARED.ID_DOCENTE) && (
              <Adjuntado
                miniatura={data.urlDocumento && IMAGE_DNI}
                title="DOCUMENTO DE IDENTIDAD"
                type="documento_identidad"
                downloadFileName={`${data.nrodocumento}-DOC.pdf`}
                onDownload={() =>
                  previewFile("documento_identidad", `${data.nrodocumento}-DOC.pdf`)
                }
                url={data.urlDocumento}
                isUrlOk={data.isDocumentoOk}
                urlOkName="isDocumentoOk"
                changeAttachedState={changeAttachedState}
              />
            )}

            <Adjuntado
              miniatura={data.urlDeclaracionJurada && IMAGE_DECLARACION_JURADA}
              title="DECLARACIÓN JURADA"
              type="declaracion_jurada"
              downloadFileName={`${data.nrodocumento}-DJ.pdf`}
              onDownload={() => previewFile("declaracion_jurada", `${data.nrodocumento}-DJ.pdf`)}
              url={data.urlDeclaracionJurada}
              isUrlOk={data.isDeclaracionJuradaOk}
              urlOkName="isDeclaracionJuradaOk"
              changeAttachedState={changeAttachedState}
            />

            <Adjuntado
              miniatura={data.urlFoto && IMAGE_FOTO_DEL_ROSTRO}
              title="FOTO DEL ROSTRO"
              type="foto_rostro"
              downloadFileName={`${data.nrodocumento}-FOT.jpg`}
              onDownload={() => previewFile("foto_rostro", `${data.nrodocumento}-FOT.jpg`)}
              url={data.urlFoto}
              isUrlOk={data.isFotoOk}
              urlOkName="isFotoOk"
              changeAttachedState={changeAttachedState}
            />

            <Adjuntado
              miniatura={data.urlCurriculum && IMAGE_CURRICULUM_VITAE}
              title="CURRICULUM VITAE"
              type="carne_vacunacion"
              downloadFileName={`${data.nrodocumento}-VAC.pdf`}
              onDownload={() => previewFile("carne_vacunacion", `${data.nrodocumento}-VAC.pdf`)}
              url={data.urlCurriculum}
              isUrlOk={data.isCurriculumOk}
              urlOkName="isCurriculumOk"
              changeAttachedState={changeAttachedState}
            />
          </div>

          {/* ---------- ACTUALIZAR ESTADO ---------- */}

          <hr />
          <h2 className="text-md font-bold my-4 text-blue-500">ACTUALIZAR ESTADO</h2>

          <Radio.Group
            className="flex flex-wrap text-center"
            buttonStyle="solid"
            value={data.idestado}
            onChange={(e) => showChangeStateConfirm(e.target.value)}
          >
            <Radio.Button
              value={SHARED.ID_ESTADO_NO_INSCRITO}
              className="flex-1"
              style={{ minWidth: "100px" }}
            >
              {SHARED.NO_INSCRITO}
            </Radio.Button>
            <Radio.Button value={SHARED.ID_ESTADO_PENDIENTE} className="flex-1">
              {SHARED.PENDIENTE}
            </Radio.Button>
            <Radio.Button value={SHARED.ID_ESTADO_OBSERVADO} className="flex-1">
              {SHARED.OBSERVADO}
            </Radio.Button>
            <Radio.Button value={SHARED.ID_ESTADO_VALIDADO} className="flex-1">
              {SHARED.VALIDADO}
            </Radio.Button>
            {/* <Radio.Button value={SHARED.ID_ESTADO_SORTEADO} className="flex-1">
              {SHARED.SORTEADO}
            </Radio.Button> */}
          </Radio.Group>

          {isAdmin && (
            <Fragment>
              <h2 className="text-md font-bold my-4 text-blue-500">
                DATOS DE ACCESO &nbsp;
                <Button className="absolute" size="small" onClick={toggleVisibleDatos}>
                  {React.createElement(isDatosAccesoVisible ? EyeInvisibleOutlined : EyeOutlined)}
                </Button>
              </h2>

              {isDatosAccesoVisible && (
                <Fragment>
                  <div className="flex">
                    <p>Correo:</p>&nbsp; &nbsp;
                    <p className="text-gray-400">{data.email}</p>
                  </div>
                  <div className="flex">
                    <p>Contraseña:</p> &nbsp; &nbsp;
                    <p className="text-gray-400">{data.password}</p>
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
}

export default Revision;
